module.exports = __webpack_public_path__ + "img/golden-1.4d3a5ac8.jpg";